import * as d3 from "d3";

export function d3map() {
  const topojson = require("topojson");

  /////////////////////////////////////////////////////////////
  //Color Legend code
  // console.log("inside d3map");
  function legend({
    color,
    title,
    tickSize = 6,
    width = 320,
    height = 44 + tickSize,
    marginTop = 18,
    marginRight = 0,
    marginBottom = 16 + tickSize,
    marginLeft = 0,
    ticks = width / 64,
    tickFormat,
    tickValues
  } = {}) {
    //🚧  explain

    const svg = d3
      .create("svg")
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [0, 0, width, height])
      .style("overflow", "visible")
      .style("display", "block");

    let x;

    var format1 = d => {
      var p = Math.floor(Math.log(d) / Math.LN10);
      var n = Math.round(d * Math.pow(10, -p), 2);
      // console.log(n + "e" + p);
      return n + "e" + p;
    };

    // Continuous
    if (color.interpolator) {
      x = Object.assign(
        color
          .copy()
          .interpolator(d3.interpolateRound(marginLeft, width - marginRight)),
        {
          range() {
            return [marginLeft, width - marginRight];
          }
        }
      );

      svg
        .append("image")
        .attr("x", marginLeft)
        .attr("y", marginTop)
        .attr("width", width - marginLeft - marginRight)
        .attr("height", height - marginTop - marginBottom)
        .attr("preserveAspectRatio", "none")
        .attr("xlink:href", ramp(color.interpolator()).toDataURL());

      // scaleSequentialQuantile doesn’t implement ticks or tickFormat.

      if (!x.ticks) {
        if (tickValues === undefined) {
          const n = Math.round(ticks + 1);
          tickValues = d3
            .range(n)
            .map(i => format1(d3.quantile(color.domain(), i / (n - 1))));
        }
        if (typeof tickFormat !== "function") {
          tickFormat = d3.format(tickFormat === undefined ? ",f" : tickFormat);
        }
      }
    }

    // Discrete
    else if (color.invertExtent) {
      const thresholds = color.thresholds
        ? color.thresholds() // scaleQuantize
        : color.quantiles
        ? color.quantiles() // scaleQuantile
        : color.domain(); // scaleThreshold

      const thresholdFormat =
        tickFormat === undefined
          ? d => d
          : typeof tickFormat === "string"
          ? d3.format(tickFormat)
          : tickFormat;

      x = d3
        .scaleLinear()
        .domain([-1, color.range().length - 1])
        .rangeRound([marginLeft, width - marginRight]);

      svg
        .append("g")
        .selectAll("rect")
        .data(color.range())
        .join("rect")
        .attr("x", (d, i) => x(i - 1))
        .attr("y", marginTop)
        .attr("width", (d, i) => x(i) - x(i - 1))
        .attr("height", height - marginTop - marginBottom)
        .attr("fill", d => d);

      tickValues = d3.range(thresholds.length);

      tickFormat = i => thresholdFormat(format1(thresholds[i]), i);
    }

    svg
      .append("g")
      .attr("transform", `translate(0, ${height - marginBottom})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(ticks, typeof tickFormat === "string" ? tickFormat : undefined)
          .tickFormat(typeof tickFormat === "function" ? tickFormat : undefined)
          .tickSize(tickSize)
          .tickValues(tickValues)
      )
      .call(g =>
        g.selectAll(".tick line").attr("y1", marginTop + marginBottom - height)
      )
      .call(g => g.select(".domain").remove())
      .call(g =>
        g
          .append("text")
          .attr("y", marginTop + marginBottom - height - 6)
          .attr("fill", "currentColor")
          .attr("text-anchor", "start")
          .attr("font-weight", "bold")
          .text(title)
      );

    return svg.node();
  }

  function ramp(color, n = 256) {
    const canvas = this.$refs.canvas(n, 1);
    const context = canvas.getContext("2d");
    for (let i = 0; i < n; ++i) {
      context.fillStyle = color(i / (n - 1));
      context.fillRect(i, 0, 1, 1);
    }
    return canvas;
  }

  /////////////////////////////////////////////////////////////
  //Choropleth code

  var svg = d3.select("#chart"),
    width = +svg.attr("width"),
    height = +svg.attr("height");

  var promises = [];

  promises.push(d3.json("./data/countries-10m.json"));
  promises.push(d3.csv("./data/emission_data_selected.csv"));

  Promise.all(promises).then(function(values) {
    //🚧  explain
    var world = values[0];
    var data = values[1];

    var countries = new Map(
      world.objects.countries.geometries.map(d => [d.id, d.properties])
    ); //🚧  explain
    // console.log(countries);
    // console.log("well working");

    var format = d => `${d}`;

    var path = d3.geoPath();

    var color = d3.scaleQuantize([4300000, 399000000000], d3.schemeReds[9]); //🚧  explain

    //original line from Observable

    //data = Object.assign(new Map(await d3.csv("unemployment.csv", ({id, rate}) => [id, +rate])), {title: "Unemployment rate (%)"})
    data = Object.assign(new Map(data.map(d => [d.id, +d.value]))); //🚧  explain

    data.title = "tonnes";

    var projection = d3
      .geoMercator()
      .fitSize(
        [width, height],
        topojson.feature(world, world.objects.countries)
      );

    path = d3.geoPath().projection(projection);

    // const svg = d3.create("svg")
    // svg = d3.select("#chart").attr("viewBox", [0, 0, 975, 610]);

    svg
      .append("g")
      .attr("transform", "translate(10,400)")
      .append(() => legend({ color, title: data.title, width: 260 }));

    svg
      .append("g")
      .selectAll("path")
      .data(topojson.feature(world, world.objects.countries).features) //🚧  explain
      .join("path")
      .attr("fill", d => (data.get(d.id) ? color(data.get(d.id)) : "#ccc"))
      .attr("d", path)
      .append("title")
      .text(d => `${d.properties.name}, ${format(data.get(d.id))}`); //🚧  explain

    svg
      .append("path")
      .datum(topojson.mesh(world, world.objects.countries, (a, b) => a !== b)) //🚧  explain
      .attr("fill", "none")
      .attr("stroke", "white")
      .attr("stroke-linejoin", "round")
      .attr("d", path);
  });
}
